"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.averageForEntries = exports.entriesPerPercentileForScale = exports.PollResults = void 0;
const lodash_1 = __importDefault(require("lodash"));
var PollResults;
(function (PollResults) {
    function fromUserReferenceAndEntries(entries, pin) {
        return pollLessonResults(entries, pin);
    }
    PollResults.fromUserReferenceAndEntries = fromUserReferenceAndEntries;
    function pollLessonResults(entries, pin) {
        const base = {
            users: entries.map((entry) => entry.user),
        };
        // TODO: remove any type
        const distribuutionDataMethods = {
            scale: scaleLessonResults,
            multipleChoice: multipleChoiceLessonResults,
            emoji: emojiLessonResults,
        };
        // const results = distribuutionDataMethods[pin.item.custom.answerType](entries, pin as any);
        // TODO: Fix Poll answer types
        const results = 'todo';
        return {
            _id: pin._id,
            ...base,
            ...results,
        };
    }
    PollResults.pollLessonResults = pollLessonResults;
    function multipleChoiceLessonResults(entries, pin) {
        const groupedEntries = lodash_1.default.groupBy(entries, (entry) => entry.pinEntry?.answer?.value);
        // TODO: remove any type
        // const distribution = pin.item.custom.options.map((option: any, index: any) => {
        //   const displayValue =
        //     option.type === 'image' ? { url: option.url, backgroundSize: option.backgroundSize } : { text: option.text };
        //   return {
        //     key: option.value,
        //     ...displayValue,
        //     users: groupedEntries[index]?.map((entry) => entry.user._id) || [],
        //   };
        // });
        // TODO: Fix distribution
        const distribution = 'todo';
        return {
            type: 'multipleChoice',
            distribution,
        };
    }
    function emojiLessonResults(entries, pin) {
        const groupedEntries = lodash_1.default.groupBy(entries, (entry) => entry.pinEntry?.answer?.value);
        // TODO: remove any type
        // const distribution = pin.item.custom.options.map((option: any, index: any) => ({
        //   key: index,
        //   text: option,
        //   users: groupedEntries[index]?.map((entry) => entry.user._id) || [],
        // }));
        // TODO: Fix distribution
        const distribution = 'todo';
        return {
            type: 'emoji',
            distribution,
        };
    }
    function scaleLessonResults(entries, pin) {
        const entriesWithAnswer = entries.filter((e) => e.pinEntry?.answer);
        return {
            type: 'scale',
            average: averageForEntries(lodash_1.default.compact(entriesWithAnswer.map((entry) => entry.pinEntry))),
        };
    }
    PollResults.scaleLessonResults = scaleLessonResults;
})(PollResults || (exports.PollResults = PollResults = {}));
function entriesPerPercentileForScale(entries, scaleSize) {
    return lodash_1.default.groupBy(entries, (entry) => {
        const value = (entry.answer.value / scaleSize) * 100;
        const percentile = Math.ceil((value + 1) / 10) * 10;
        return percentile;
    });
}
exports.entriesPerPercentileForScale = entriesPerPercentileForScale;
function averageForEntries(pinEntries) {
    const entriesWithAnswer = lodash_1.default.filter(pinEntries, (entry) => entry && typeof entry.answer?.value !== 'undefined');
    return entriesWithAnswer.map((entry) => entry.answer).reduce((a, b) => a + b.value, 0) / entriesWithAnswer.length;
}
exports.averageForEntries = averageForEntries;
//# sourceMappingURL=PollResults.js.map